import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { site } from "@/config/site";

const Block = ({ title, children }) => (
  <Reveal className="border-b border-line pb-8 last:border-0">
    <h2 className="font-serif text-2xl font-semibold text-navy">{title}</h2>
    <div className="mt-4 space-y-3 text-sm leading-relaxed text-slate-600">{children}</div>
  </Reveal>
);

export default function Terms() {
  return (
    <>
      <Seo title="Terms & Conditions | HM Services" description="The terms that govern the use of the HM Services website and our hospitality consultancy services." path="/terms" />
      <PageHero eyebrow="Legal" title="Terms & Conditions" subtitle="Please review these terms regarding the use of our website and services." />
      <section className="bg-white py-20 lg:py-28">
        <div className="mx-auto max-w-3xl space-y-10 px-5 sm:px-8">
          <Block title="Website Use">
            <p>By using this website, you agree to use it lawfully and not to misuse any content, forms or functionality provided.</p>
          </Block>
          <Block title="Services">
            <p>HM Services provides hospitality consultancy and digital growth services. The specific scope of any engagement is agreed directly with each client based on the selected package and requirements.</p>
          </Block>
          <Block title="Property Owner Responsibilities & Accuracy of Information">
            <p>You are responsible for providing accurate and complete information about your property. The quality and accuracy of listings depend on the information and materials you provide.</p>
          </Block>
          <Block title="Third-Party Platforms">
            <p>Our services may involve third-party platforms (such as Booking.com, Airbnb, Agoda, Expedia, Google and Tripadvisor). These platforms operate under their own terms and policies, and we do not control their decisions, rankings or availability.</p>
          </Block>
          <Block title="Payments">
            <p>Fees are based on the agreed package and scope of work and are communicated directly to each client. Specific payment terms are established as part of each engagement.</p>
          </Block>
          <Block title="Cancellation & Refunds">
            <p>Cancellation and refund arrangements are agreed on a per-engagement basis and communicated directly to clients before work begins.</p>
          </Block>
          <Block title="Intellectual Property">
            <p>Website content, branding and materials belong to HM Services unless otherwise stated and may not be reproduced without permission.</p>
          </Block>
          <Block title="Limitation of Liability">
            <p>HM Services focuses on improving your online presence, listing quality and visibility. We do not guarantee specific bookings, revenue, occupancy or platform rankings, as these depend on many factors beyond our control.</p>
          </Block>
          <Block title="Contact">
            <p>For questions about these terms, contact us at <a href={`mailto:${site.email}`} className="font-medium text-ocean">{site.email}</a>.</p>
          </Block>
        </div>
      </section>
    </>
  );
}
